export const SORT_NONE = " ";
export const SORT_MODIFICATION_DATE = "MODIFICATION_DATE";
export const SORT_CREATION_DATE = "CREATION_DATE";
export const SORT_PRICE_ASC = "PRICE_ASC";
export const SORT_PRICE_DESC = "PRICE_DESC";
export const SORT_AREA_ASC = "AREA_ASC";
export const SORT_AREA_DESC = "AREA_DESC";
export const SORT_POSTCODE_ASC = "POSTCODE_ASC";
export const SORT_POSTCODE_DESC = "POSTCODE_DESC";

export const SORTING_OPTIONS = [
  { value: SORT_NONE, label: "housingSort.none" },
  { value: SORT_MODIFICATION_DATE, label: "housingSort.modification_date" },
  { value: SORT_CREATION_DATE, label: "housingSort.creation_date" },
  { value: SORT_PRICE_ASC, label: "housingSort.price_asc" },
  { value: SORT_PRICE_DESC, label: "housingSort.price_desc" },
  { value: SORT_AREA_ASC, label: "housingSort.area_asc" },
  { value: SORT_AREA_DESC, label: "housingSort.area_desc" },
  { value: SORT_POSTCODE_ASC, label: "housingSort.postcode_asc" },
  { value: SORT_POSTCODE_DESC, label: "housingSort.postcode_desc" },
];
